import { defineAsyncComponent } from 'vue'
export default {
  "application-root": defineAsyncComponent(() => import("/app/apps/dashboard/src/layouts/application-root.vue").then(m => m.default || m))
}